import { httpClient } from "./httpClient";

const getSitebyName = (IdScgSite) => {
  return httpClient.get("site_by_name/" + IdScgSite);
};
// const addLocationDriver = (data) => {
//   return httpClient.post("add_location_driver/add", data);
// };
const addDeliverySampleLocationDriver = (data) => {
  return httpClient.post("add_delivery_sample_location_driver/add", data);
};
const getLocationAndVehicleUsage = (idDriver) => {
  return httpClient.get("get_location_vehicle_usage_by_id/" + idDriver);
};
const setDeliverySampleLocationDriverByIdUsage = (data) => {
  return httpClient.post("update_delivery_sample_location_driver", data);
};
const getLocationDriverById = (idDriver) => {
  return httpClient.get("get_location_Driver_by_id/" + idDriver);
};

const getAllLocationDriver = () => {
  return httpClient.get("get_all_location_Driver");
};
const getAllSites = (idCompany) => {
  return httpClient.get(`get_all_site/${idCompany}`);
};
const getAllSiteLocations = (idCompany = "") => {
  return httpClient.get(`get_all_site_location/${idCompany}`);
};
const addSite = (data) => {
  return httpClient.post("add_site/add", data);
};
const addSiteLocation = (data) => {
  return httpClient.post("add_site_location/add", data);
};
const setSite = (data) => {
  return httpClient.post("update_site", data);
};
const setSiteLocation = (data) => {
  return httpClient.post("update_site_location", data);
};
const deleteSite = (idSite) => {
  return httpClient.delete(`delete_site/${idSite}`);
};
const deleteSiteLocation = (idScgSite) => {
  return httpClient.delete(`delete_site_location/${idScgSite}`);
};
const addLocationDriver = (data) => {
  return httpClient.post("add_location_driver/add", data);
};
const setLocationDriver = (data) => {
  return httpClient.post("update_location_driver", data);
};
export default {
  getSitebyName,
  // addLocationDriver,
  addDeliverySampleLocationDriver,
  getLocationAndVehicleUsage,
  setDeliverySampleLocationDriverByIdUsage,
  getLocationDriverById,
  getAllLocationDriver,
  getAllSites,
  getAllSiteLocations,
  addSite,
  addSiteLocation,
  setSite,
  setSiteLocation,
  deleteSite,
  deleteSiteLocation,
  addLocationDriver,
  setLocationDriver,
};
